import React, { Component } from "react";
import {FlexGrid, FlexGridItem} from 'baseui/flex-grid';
import logo_128 from '../images/enclock_128x128.png';
import {Button, SIZE } from 'baseui/button';
import {HeadingSmall, ParagraphLarge} from 'baseui/typography';
import * as ROUTES from '../Routes';

import './style.css';

class NotFound extends Component {
    render = () => {
        return <div className="App">
            <header className="style-404">
                <FlexGrid flexGridRowGap="scale800">
                    <FlexGridItem><img alt={''} src={logo_128} style={{marginTop: '50px'}}/></FlexGridItem>
                    <FlexGridItem><HeadingSmall style={{margin: 0}}>Page not found</HeadingSmall></FlexGridItem>
                    <FlexGridItem><ParagraphLarge style={{margin: 'auto', maxWidth: '600px'}}>This page does not seem to exist, has been deleted or has been moved... Please use the navigation menu to navigate around for better results.</ParagraphLarge></FlexGridItem>
                    <FlexGridItem><Button size={SIZE.default} $as={'a'} href={ROUTES.WALL}>Sounds good</Button></FlexGridItem>
                </FlexGrid>
            </header>
        </div>
    };
}

export default NotFound;
